var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.75413 8.72311C10.0469 9.01513 10.0469 9.48892 9.75413 9.78097C9.46132 10.073 8.98623 10.073 8.69339 9.78097L5.00051 6.07065L1.28137 9.77973C0.988563 10.0717 0.513483 10.0717 0.22064 9.77973C-0.0722028 9.48771 -0.0721715 9.01391 0.22064 8.72186L3.94102 5.01403L0.219609 1.27689C-0.0732029 0.984874 -0.0732029 0.511078 0.219609 0.219027C0.51242 -0.0730245 0.987501 -0.0729933 1.28034 0.219027L5.00051 3.95741L8.71964 0.248325C9.01246 -0.0436948 9.48754 -0.0436948 9.78038 0.248325C10.0732 0.540345 10.0732 1.01414 9.78038 1.30619L6.05999 5.01403L9.75413 8.72311Z"}));
}

Close.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = Close;

Close.default = Close;
